/* salon list page */
export const GET_CATEGORIES = "GET_CATEGORIES";
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";
export const GET_SALON_LIST = "GET_SALON_LIST";
export const GET_SALON_LIST_SUCCESS = "GET_SALON_LIST_SUCCESS";

/* location related */
export const LOC_FOUND = "LOC_FOUND";
export const LOC_DENIED = "LOC_DENIED";

export const POST_UID = "POST_UID";

/* salon details */
export const GET_SALON_DETAILS = "GET_SALON_DETAILS";
export const GET_SALON_DETAILS_SUCCESS = "GET_SALON_DETAILS_SUCCESS";
export const ACTIVATE_SALON = "ACTIVATE_SALON";
export const DEACTIVATE_SALON = "DEACTIVATE_SALON";

/* save selected services */
export const SAVE_SELECTED_SERVICES = "SAVE_SELECTED_SERVICES";

/* my bookings */
export const GET_MY_BOOKINGS = "GET_MY_BOOKINGS";
export const GET_MY_BOOKINGS_SUCCESS = "GET_MY_BOOKINGS_SUCCESS";
export const CANCEL_BOOKINGS = "CANCEL_BOOKINGS";
export const COMPLETE_APPOINTMENT = `COMPLETE_APPOINTMENT`;
export const GENERATE_BILL = `GENERATE_BILL`;

/* book apointment */
export const FIND_AVAILABLE_SLOTS = "FIND_AVAILABLE_SLOTS";
export const FIND_AVAILABLE_SLOTS_SUCCESS = "FIND_AVAILABLE_SLOTS_SUCCESS";
export const BOOK_APPOINTMENT = "BOOK_APPOINTMENT";
export const BOOK_APPOINTMENT_SUCCESS = "BOOK_APPOINTMENT_SUCCESS";

/*add salon */
export const ADD_SALON = "ADD_SALON";
export const ADD_SALON_SUCCESS = "ADD_SALON_SUCCESS";
export const ADD_SALON_IMAGE = "ADD_SALON_IMAGE";
export const ADD_LOGO_IMAGE = "ADD_LOGO_IMAGE";
export const ADD_SALON_IMAGE_SUCCESS = "ADD_SALON_IMAGE_SUCCESS";
export const NEW_SALON_REGISTERED = "NEW_SALON_REGISTERED";

export const UPDATE_SALON = "UPDATE_SALON";

/*salon services*/
export const GET_SALON_SERVICES = "GET_SALON_SERVICES";
export const GET_SALON_SERVICES_SUCCESS = "GET_SALON_SERVICES_SUCCESS";
export const ADD_SALON_SERVICE = "ADD_SALON_SERVICE";
export const ADD_SALON_SERVICE_SUCCESS = "ADD_SALON_SERVICE_SUCCESS";
export const DELETE_SERVICE = "DELETE_SERVICE";
export const EDIT_SERIVCE = "EDIT_SERIVCE";

/*salon appoinetns*/
export const GET_SALON_ALL_APPOINTMENTS = `GET_SALON_ALL_APPOINTMENTS`;
export const GET_SALON_ALL_APPOINTMENTS_SUCCESS = `GET_SALON_ALL_APPOINTMENTS_SUCCESS`;
export const CONFIRM_APPOINTMENTS = `CONFIRM_APPOINTMENTS`;
export const DECLINE_APPOINTMENTS = `DECLINE_APPOINTMENTS`;

/*feedback */
export const SUBMIT_FEEDBACK = `SUBMIT_FEEDBACK`;

/* analytics */
export const GET_ANALYTICS = `GET_ANALYTICS`;
export const GET_ANALYTICS_SUCCESS = `GET_ANALYTICS_SUCCESS`;

/* search user */
export const SEARCH_USER = "SEARCH_USER";
export const SEARCH_USER_SUCCESS = "SEARCH_USER_SUCCESS";

/* expenses */
export const ADD_EXPENSES = "ADD_EXPENSES";
export const VIEW_EXPENSES = "VIEW_EXPENSES";
export const VIEW_EXPENSES_SUCCESS = "VIEW_EXPENSES_SUCCESS";
export const DELETE_EXPENSES = "DELETE_EXPENSES";
export const UPDATE_EXPENSES = "UPDATE_EXPENSES";

/*Rating */
export const UNRATED_APPOINTMENTS = "GET_UNRATED_APPOINTMENTS";
export const UNRATED_APPOINTMENTS_SUCCESS = "GET_UNRATED_APPOINTMENTS_SUCCESS";
export const SUBMIT_RATING = "SUBMIT_RATING";
export const SUBMIT_RATING_SUCCESS = "SUBMIT_RATING_SUCCESS";

/*location*/
export const GET_LOCATION = "GET_LOCATION";
export const GET_LOCATION_SUCCESS = "GET_LOCATION_SUCCESS";

/*top salons*/
export const GET_TOP_SALONS = "GET_TOP_SALONS";
export const SET_TOP_SALONS = "SET_TOP_SALONS";

/*user address*/
export const ADD_USER_ADDRESS = "ADD_USER_ADDRESS";
export const GET_USER_ADDRESS = "GET_USER_ADDRESS";
export const SET_USER_ADDRESS = "SET_USER_ADDRESS";
export const DEACTIVATE_USER_ADDRESS = "DEACTIVATE_USER_ADDRESS";
export const UPDATE_USER_ADDRESS = "UPDATE_USER_ADDRESS";

/*promo codes */
export const ADD_PROMO = "ADD_PROMO";
export const ADD_PROMO_SUCCESS = "ADD_PROMO_SUCCESS";
export const VIEW_PROMO = "VIEW_PROMO";
export const VIEW_PROMO_SUCCESS = "VIEW_PROMO_SUCCESS";
export const DELETE_PROMO = "DELETE_PROMO";
export const EDIT_PROMO = "EDIT_PROMO";
export const GET_PROMO = "GET_PROMO";
export const GET_PROMO_SUCCESS = "GET_PROMO_SUCCESS";
